export const styleLeftRow = `
    flex-flow:row wrap;
    row-gap:15px;
    width:73%;
    @media(max-width:767px){
        width:100%;
    }
    
`
export const styleRightRow = `
    width:24%;
    @media(max-width:767px){
        width:100%;
    }
`
export const styleInputWrapper = `
    width:48%;
    @media(max-width:767px){
        width:100%;
    }
`
